module.exports = __webpack_public_path__ + "img/destination_arrow_long.f86583f5.svg";